import { render, staticRenderFns } from "./modalAddGroupMembers.vue?vue&type=template&id=1f5f33a2&"
import script from "./modalAddGroupMembers.vue?vue&type=script&lang=js&"
export * from "./modalAddGroupMembers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports